/**
 * Зависимости
 */
import MapFilter from 'components/yandex-map/infrastructure-checkbox-filter';
import Observer from 'common/scripts/observer';
import Swiper from 'swiper';
import {Utils} from 'common/scripts/utils';
import YandexMap from 'components/yandex-map';

const observer = new Observer();

/**
  * Карта в блоке Расположение
  */
const filterListBtn = document.querySelector('.j-infrastructure-filter-list-toggle');
const filterList = document.querySelector('.j-infrastructure-list');
const locationMap = document.querySelector('.j-infrastructure-map');
const filterCheckboxToggler = document.querySelector('.j-checkbox-toggle');
const mapFilterWrapper = document.querySelector('.j-map-filter');
const closeBtn = document.querySelector('.j-map-filter-close');
const overlayFilter = document.querySelector('.j-map-filter-overlay');

let isLoaded = false;

const closeFilter = () => {
    filterList.classList.toggle('is-open');
    filterListBtn.classList.toggle('is-open');
};

const initLocationMap = () => {
    isLoaded = true;

    if (mapFilterWrapper) {
        const mapFilter = new MapFilter();

        mapFilter.init({target: mapFilterWrapper});

        if (Utils.getWindowWidth() > 1279) {
            filterCheckboxToggler.querySelector('span').innerHTML = 'Все';
        }

        if (filterCheckboxToggler) {
            observer.subscribe('filterUpdated', () => {
                const togglerText = filterCheckboxToggler.querySelector('span');

                if (Utils.getWindowWidth() < 1280) {
                    togglerText.innerHTML = mapFilter.globalFilterState ? 'Скрыть все' : 'Показать все';
                } else {
                    togglerText.innerHTML = 'Все';
                }
            });

            filterCheckboxToggler.addEventListener('click', () => {
                // mapFilter.changeCheckBoxState();
                mapFilter.showAll(filterCheckboxToggler);
            });
        }
    }

    if (filterListBtn && filterList) {
        filterListBtn.addEventListener('click', () => {
            closeFilter();
        });
    }

    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            const yandexMap = new YandexMap(ymaps);

            yandexMap.init({
                wrapper                : locationMap,
                cluster                : true,
                fullScreenControl      : true,
                customFullScreenControl: true,
                customZoomControl      : true
            });
        });
    }
};

if (closeBtn) {
    closeBtn.addEventListener('click', () => {
        closeFilter();
    });
}

if (overlayFilter) {
    overlayFilter.addEventListener('click', () => {
        closeFilter();
    });
}

const checkMap = () => {
    const ymaps = window.ymaps;

    if (ymaps) {
        initLocationMap();
    } else {
        Utils.loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', initLocationMap);
    }
};

if (locationMap) {
    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!isLoaded) {
                        checkMap();
                    }
                }
            });
        }, {rootMargin: '0px 0px 1000px 0px'});

        if (Utils.isInViewport(locationMap, window.innerHeight || document.documentElement.clientHeight)) {
            checkMap();
        } else {
            lazyImageObserver.observe(locationMap);
        }
    } else {
        checkMap();
    }
}

/**
 * Слайдер преимуществ
 */
const projectNearSlider = document.querySelector('.j-project-near-slider');

if (projectNearSlider) {
    let slider = {};
    const options = {
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 35,
        allowTouchMove   : true
    };

    slider = new Swiper(projectNearSlider, options);
    slider.init();
}

